import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';

const headerCellSx = {
  fontWeight: 700,
  fontSize: { xs: '14px !important', md: '16px !important' },
  color: '#000',
  whiteSpace: 'nowrap',
};

const bodyCellSx = {
  color: '#1A1A1A',
  fontWeight: 400,
  fontSize: { xs: '14px !important', md: '16px !important' },
  px: { xs: 1.5, md: 2 },
};

export default function SearchResultsTable({ users, onRowClick }) {
  return (
    <Box mt={{ xs: 3, md: 5 }}>
      <Box
        display="flex"
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        flexDirection={{ xs: 'column', sm: 'row' }}
        gap={{ xs: 0.5, sm: 2 }}
        mb={2}
      >
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: { xs: '16px !important', md: '18px !important' },
            color: '#000',
          }}
        >
          {users.length} match
          {users.length > 1 ? 'es' : ''}
        </Typography>

        <Typography sx={{ fontWeight: 400, fontSize: '14px !important', color: '#000' }}>
          Click a row to open the User Detail Page.
        </Typography>
      </Box>

      <TableContainer
        component={Paper}
        sx={{
          borderRadius: 2,
          // Scroll horizontally on narrow screens instead of clipping columns.
          overflowX: 'auto',
          border: '1px solid #E5E5E5',
          boxShadow: 'none',
        }}
      >
        <Table sx={{ minWidth: 560 }}>
          <TableHead>
            <TableRow
              sx={{
                bgcolor: '#F8F7F5',
                '& th': {
                  fontWeight: 700,
                  borderBottom: '2px solid #F28C28',
                  px: { xs: 1.5, md: 2 },
                },
              }}
            >
              <TableCell sx={headerCellSx}>Name</TableCell>
              <TableCell sx={headerCellSx}>Username</TableCell>
              <TableCell sx={headerCellSx}>Email</TableCell>
              <TableCell sx={headerCellSx}>Type</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {users.map((user) => (
              <TableRow
                key={user.id}
                hover
                onClick={() => onRowClick(user)}
                sx={{
                  cursor: 'pointer',
                }}
              >
                <TableCell sx={{ ...bodyCellSx, color: '#C62828' }}>{user.name}</TableCell>

                <TableCell sx={bodyCellSx}>{user.username}</TableCell>

                <TableCell sx={{ ...bodyCellSx, overflowWrap: 'anywhere' }}>{user.email}</TableCell>

                <TableCell sx={bodyCellSx}>
                  {user.registeredfrom === 'externalcreditlens' ? 'Commercial' : 'Retail'}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

SearchResultsTable.propTypes = {
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string,
      username: PropTypes.string,
      email: PropTypes.string,
      contact: PropTypes.string,
      type: PropTypes.string,
      status: PropTypes.string,
    })
  ).isRequired,

  onRowClick: PropTypes.func.isRequired,
};
